// Styles
import styles from "./ContactContent.module.scss";
// Image
import scheduleImage from "../../../assets/images/schedule_image.png";
import ContactForm from "../ContactForm/ContactForm";

const ContactContent = () => {
  const handlePrivacyPolicyClick = () => {
    window.open("https://www.magnapest.com/privacy");
  };

  return (
    <div className={styles.root}>
      <div className={styles.contactSection}>
        <h1 className={styles.title}>How can we reach you?</h1>
        <p className={styles.description}>
          We need more details to set up your service
        </p>
        <ContactForm />
        <p className={styles.permission}>
          By submitting this request, I validate that I am 18 years of age or
          older. Additionally, I give Magna Pest Solutions permission to email,
          call or text me at the number provided regarding services provided by
          Magna Pest Solutions. I understand that my consent is not a condition
          of purchase. Message and data rates might apply. View{" "}
          <span
            className={styles.privacyPolicy}
            onClick={handlePrivacyPolicyClick}>
            Privacy Policy
          </span>
          .
        </p>
      </div>
      <div className={styles.imageSection}>
        <img src={scheduleImage} alt="placeholder" />
      </div>
    </div>
  );
};

export default ContactContent;
